import {
  HandHeart,
  Stethoscope,
  UtensilsCrossed,
  Users,
  Sparkles,
  type LucideIcon,
} from "lucide-react";

/** `value` is the English label sent to the API; `key` is the i18n key. */
export type CsrOption = { value: string; key: string };

export type CsrArea = CsrOption & { icon: LucideIcon };

export const CSR_AREAS: CsrArea[] = [
  { value: "Elderly Care", key: "csr.areas.elderlyCare", icon: HandHeart },
  { value: "Healthcare", key: "csr.areas.healthcare", icon: Stethoscope },
  { value: "Nutritious Meals", key: "csr.areas.meals", icon: UtensilsCrossed },
  { value: "Community Welfare", key: "csr.areas.community", icon: Users },
  {
    value: "Women Empowerment through Gruh Udhyog",
    key: "csr.areas.women",
    icon: Sparkles,
  },
];

export const CSR_CONTRIBUTIONS: CsrOption[] = [
  { value: "Below ₹50,000", key: "csr.options.contribution.below50k" },
  { value: "₹50,000 – ₹1,00,000", key: "csr.options.contribution.50kTo1L" },
  { value: "₹1,00,000 – ₹5,00,000", key: "csr.options.contribution.1LTo5L" },
  { value: "₹5,00,000 – ₹10,00,000", key: "csr.options.contribution.5LTo10L" },
  { value: "Above ₹10,00,000", key: "csr.options.contribution.above10L" },
  { value: "To be discussed", key: "csr.options.contribution.discuss" },
];

export const CSR_DURATIONS: CsrOption[] = [
  { value: "One-time Contribution", key: "csr.options.duration.oneTime" },
  { value: "3–6 Months", key: "csr.options.duration.3To6" },
  { value: "6–12 Months", key: "csr.options.duration.6To12" },
  { value: "Long-term Partnership", key: "csr.options.duration.longTerm" },
];
